import moment from 'moment'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { currencyMask } from 'src/components/Formik'
import { R12Data } from 'src/store/ducks/reports/types'
import * as Css from './styles'

interface ListProps extends Readonly<{ items: R12Data[] }> {}

function Header() {
  const { t } = useTranslation()
  return (
    <>
      <div>{t('web.report.12.data.date')}</div>
      <div>{t('web.report.12.data.request-number')}</div>
      <div>{t('web.report.12.data.quantity')}</div>
      <div>{t('web.report.12.data.total')}</div>
    </>
  )
}

export function List({ items = [] }: ListProps) {
  return (
    <Css.List
      dataSource={items}
      header={<Header />}
      itemLayout="vertical"
      renderItem={(item, index) => (
        <Css.ListAntItem odd={index % 2}>
          <Css.ListAntItemSingle>
            <span>
              {moment.unix(item.datetrunc).utc().format('DD/MM/YYYY')}
            </span>
            <span>{item.request_number}</span>
            <span>{item.quantity}</span>
            <span>
              {
                currencyMask({
                  formatStr: true,
                  precision: 2,
                  value: item.total
                }).maskedValue
              }
            </span>
          </Css.ListAntItemSingle>
          {Boolean(item.justification) && (
            <Css.ListAntItemJustification>
              {item.justification}
            </Css.ListAntItemJustification>
          )}
        </Css.ListAntItem>
      )}
    />
  )
}
